import type { OnboardingStep } from "@configs/custom-app-config-schema";
import { isWeb } from "@helpers/platform";
import { useAppTheme } from "@hooks/useAppTheme";
import { useDevice } from "@hooks/useDevice";
import Box from "@memorang/ui/src/components/Box";
import { Image } from "expo-image";
import { useTranslation } from "react-i18next";
import { Text } from "react-native-paper";
type Props = {
	welcomeOnboardingStep: OnboardingStep;
};

const Welcome = ({ welcomeOnboardingStep }: Props) => {
	const { isMediumWindowSize, isMobile } = useDevice();
	const theme = useAppTheme();
	const { t } = useTranslation();

	const source = isMobile
		? welcomeOnboardingStep.graphics?.mobile
		: isMediumWindowSize
			? welcomeOnboardingStep.graphics?.tablet
			: welcomeOnboardingStep.graphics?.desktop;

	return (
		<Box alignItems="center">
			<Image
				source={{ uri: source }}
				// @ts-expect-error calc() works on web but TypeScript doesn't recognize it
				style={{
					width: isMobile ? "100%" : 816,
					aspectRatio: isMobile ? 0.9 : 1.516,
					maxHeight: isWeb ? "calc(100vh - 308px)" : undefined,
				}}
				contentFit="contain"
			/>

			{isMobile && (
				<Text
					variant="bodyLarge"
					style={{
						color: theme.palette.text.secondary,
						textAlign: "center",
						marginTop: 16,
					}}
				>
					{t("onboarding.steps.welcome.bottomLabelMobile")}
				</Text>
			)}
		</Box>
	);
};

export default Welcome;
